import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './component.scss'

import { debounce } from 'Packs/src/subsidies/utils/debounce'

// ルートクラス定義
const ROOT_TARGET_CLASS_NAME = 'js-goToTop-root-target'
const ROOT_TARGET_SELECTOR = `.${ROOT_TARGET_CLASS_NAME}`

const goToTop = () => {
  // セレクタ定義
  const TARGET_CLASS_NAME = 'js-goToTop-button-target'
  const TARGET_SELECTOR = `.${TARGET_CLASS_NAME}`

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $goToTopTarget = $(root).find(TARGET_SELECTOR)

    const showGoToTop = () => {
      const currentPositionY = window.scrollY
      const footerPositionY = $('footer').offset().top
      const windowHeight = window.innerHeight

      if (currentPositionY <= windowHeight || currentPositionY >= (footerPositionY - windowHeight)) {
        $(root).fadeOut()
      } else {
        $(root).fadeIn()
      }
    }

    // クリックイベント登録
    $goToTopTarget.on('click', (event) => {
      event.preventDefault()

      // ページTOPへ戻る
      window.scrollTo({ top: 0, behavior: 'smooth' })
    })

    // 表示制御
    $(window).on('scroll', debounce(showGoToTop))
    $(window).on('resize', debounce(showGoToTop))

    // 初期状態判定
    showGoToTop()
  })
}

$(() => {
  // ページトップへ戻るボタンの処理
  goToTop()
})
